import { render, staticRenderFns } from "./KoioteLabel.vue?vue&type=template&id=b79902f6&scoped=true"
import script from "./KoioteLabel.vue?vue&type=script&lang=js"
export * from "./KoioteLabel.vue?vue&type=script&lang=js"
import style0 from "./KoioteLabel.vue?vue&type=style&index=0&id=b79902f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79902f6",
  null
  
)

export default component.exports